import type { ChangelogEntry } from "@/types/changelog";
import { PROV_LABEL, TYPE_LABEL, TYPE_SYM } from "@/lib/changelogLabels";

/** Stabiler Schlüssel pro Changelog-Eintrag (Review-State + React-key).
 * doc_diff_id (DD-…) und aend_id (numerisch) sind disjunkte Namespaces;
 * Komposit nur als Fallback, wenn beide fehlen. */
export function changelogEntryKey(e: ChangelogEntry): string {
  return (
    e.doc_diff_id ||
    e.aend_id ||
    `${e.doctype}|${e.format ?? ""}|${e.ort}|${e.change_type}`
  );
}

/** Feldwert für die Markdown-Story. `marked` reicht HTML durch — Werte wie
 * `QTY+220:<Menge>` verlören sonst ihren Platzhalter (bzw. würden als Markup
 * gerendert). Deshalb &, < und > als Entities. */
function orDash(s: string | null | undefined): string {
  const v = (s ?? "").trim();
  if (!v.length) return "—";
  return v.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Komponiert eine lesbare Markdown-Story aus den Eintrags-Feldern — mit den
 * deutschen Labels und Begriffen (Bisher/Neu) von Tabelle und Fensterkopf. */
export function buildChangelogStory(e: ChangelogEntry): string {
  const typ = [TYPE_SYM[e.change_type], TYPE_LABEL[e.change_type] ?? e.change_type].filter(Boolean).join(" ");
  const herkunft = PROV_LABEL[e.provenance] ?? e.provenance;
  return [
    "## Änderung",
    `**Ort:** ${orDash(e.ort)}  ·  **Typ:** ${orDash(typ)}  ·  **Herkunft:** ${orDash(herkunft)}`,
    "",
    "### Bisher",
    orDash(e.before),
    "",
    "### Neu",
    orDash(e.after),
    "",
    "### Begründung",
    orDash(e.reason),
    "",
    "### Quelle",
    `${orDash(e.source_file)}  (aend_id ${orDash(e.aend_id)}, doc-diff ${orDash(e.doc_diff_id)})`,
    "",
  ].join("\n");
}
